"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../theme");
var useStyles = (0, _theme.makeStyles)(function () {
  return {
    tooltip: function tooltip(props) {
      return {
        maxWidth: '700px',
        fontSize: '14px',
        wordWrap: 'break-word',
        boxShadow: props.shadow || '0px'
      };
    },
    arrow: function arrow(props) {
      return {
        marginBottom: '5px',
        color: props.backgroundColor || '#343434'
      };
    },
    popper: function popper(props) {
      var _props$padding;
      return {
        '& > .MuiTooltip-tooltip': {
          padding: (_props$padding = props.padding) !== null && _props$padding !== void 0 ? _props$padding : '16px 24px 16px 24px',
          background: props.backgroundColor || '#343434 0% 0% no-repeat padding-box',
          borderRadius: 4,
          whiteSpace: 'pre',
          alignItems: 'center',
          font: 'normal 14px Source Sans Pro'
        }
      };
    }
  };
}, {
  name: 'APTooltip'
});
exports.useStyles = useStyles;